import { FC, useCallback, useState } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { LOCATIONS_SEPARATOR } from '../../configs'

import { LocationsEditorDialogContent } from './components/locationsEditorDialogContent/LocationsEditorDialogContent'
import { LocationsEditorDialogFooter } from './components/locationsEditorDialogFooter/LocationsEditorDialogFooter'
import { LocationsEditorDialogHeader } from './components/locationsEditorDialogHeader/LocationsEditorDialogHeader'

interface ILocationsEditorDialogProps {
  initialLocations: string
  fieldName: string
  onCancel: () => void
}

export const LocationsEditorDialog: FC<ILocationsEditorDialogProps> = ({
  initialLocations,
  fieldName,
  onCancel,
}) => {
  const [isSaving, setIsSaving] = useState(false)
  const closeDialog = useCallback(() => {
    if (!isSaving) onCancel()
  }, [isSaving, onCancel])
  const [locations, setLocations] = useState<string[]>(
    initialLocations.split(LOCATIONS_SEPARATOR).filter((it) => it)
  )

  return (
    <ModalDialog
      show
      closeOnOutsideClick={false}
      onClose={closeDialog}
      size="sm"
      header={LocationsEditorDialogHeader}
      content={LocationsEditorDialogContent}
      footer={() => (
        <LocationsEditorDialogFooter
          locations={locations}
          fieldName={fieldName}
          onClose={onCancel}
          isSaving={isSaving}
          setIsSaving={setIsSaving}
        />
      )}
      contentProps={{
        locations,
        setLocations,
        isSaving,
      }}
    />
  )
}
